export default __webpack_public_path__ + "static/media/pharmacy sign.af7c3a91.webp";